import { gql } from '@apollo/client';

export const CALL_SUPPLIER = gql`
  mutation callSupplier($supplierId: String!, $conversationId: String!) {
    callSupplier(supplierId: $supplierId, conversationId: $conversationId) {
      message
    }
  }
`;
